(function () {
  'use strict';

  window.__c27Support = window.__c27Support || {};

  var NS = 'home';
  var bootKey = NS + 'Bootstrapped';
  var controllers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var fallbackMap = new Map();

  function controllerMap() {
    return controllers || fallbackMap;
  }

  function collectRoots(container) {
    if (!container) return [];
    var roots = [];
    if (container.matches && container.matches('[data-c27-support-component]')) {
      roots.push(container);
    }
    roots.push.apply(
      roots,
      Array.prototype.slice.call(
        container.querySelectorAll('[data-c27-support-component]')
      )
    );
    return roots;
  }

  function createController(root) {
    var component = root.getAttribute('data-c27-support-component') || '';

    if (component === 'popular-topics') {
      return createPopularTopicsController(root);
    }

    if (component === 'contact-us') {
      return createContactUsController(root);
    }

    return {
      init: function () {},
      destroy: function () {},
      getComponent: function () {
        return component;
      },
    };
  }

  function createContactUsController(root) {
    var copySuccessMs = parseInt(root.getAttribute('data-copy-success-ms') || '2000', 10);
    var copyIconDefault = root.getAttribute('data-copy-icon-default') || '';
    var copyIconSuccess = root.getAttribute('data-copy-icon-success') || '';
    var buttons = Array.prototype.slice.call(
      root.querySelectorAll('[data-c27-support-email-copy]')
    );
    var timers = new Map();
    var handlers = [];

    if (!copyIconDefault) {
      var firstIcon = root.querySelector('[data-c27-support-email-copy-icon]');
      if (firstIcon && firstIcon.getAttribute('src')) {
        copyIconDefault = firstIcon.getAttribute('src');
      }
    }

    if (!copyIconSuccess && copyIconDefault) {
      copyIconSuccess = copyIconDefault.replace('ic-copy.png', 'ic-copy-success.png');
    }

    function clearTimer(button) {
      var timerId = timers.get(button);
      if (timerId != null) {
        window.clearTimeout(timerId);
        timers.delete(button);
      }
    }

    function resetButton(button) {
      var label = button.querySelector('[data-c27-support-email-copy-label]');
      var icon = button.querySelector('[data-c27-support-email-copy-icon]');
      if (label) label.textContent = 'Copy';
      if (icon && copyIconDefault) icon.setAttribute('src', copyIconDefault);
      button.removeAttribute('data-copied');
    }

    function handleCopyClick(event) {
      var button = event.currentTarget;
      var email = button.getAttribute('data-email') || '';
      if (!email) return;

      clearTimer(button);

      function showSuccess() {
        var label = button.querySelector('[data-c27-support-email-copy-label]');
        var icon = button.querySelector('[data-c27-support-email-copy-icon]');
        if (label) label.textContent = 'Copied';
        if (icon && copyIconSuccess) icon.setAttribute('src', copyIconSuccess);
        button.setAttribute('data-copied', 'true');
        timers.set(
          button,
          window.setTimeout(function () {
            resetButton(button);
          }, copySuccessMs)
        );
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(showSuccess).catch(function () {
          resetButton(button);
        });
      } else {
        resetButton(button);
      }
    }

    return {
      init: function () {
        buttons.forEach(function (button, index) {
          var handler = handleCopyClick;
          handlers[index] = handler;
          button.addEventListener('click', handler);
        });
      },
      destroy: function () {
        buttons.forEach(function (button, index) {
          if (handlers[index]) {
            button.removeEventListener('click', handlers[index]);
          }
          clearTimer(button);
          resetButton(button);
        });
        handlers.length = 0;
      },
      getComponent: function () {
        return 'contact-us';
      },
    };
  }

  function createPopularTopicsController(root) {
    var pageSize = parseInt(root.getAttribute('data-page-size') || '6', 10);
    var totalPages = parseInt(root.getAttribute('data-total-pages') || '1', 10);
    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-c27-support-faq-item]')
    );
    var pager = root.querySelector('[data-c27-support-faq-pager]');
    var prevBtn = root.querySelector('[data-c27-support-faq-prev]');
    var nextBtn = root.querySelector('[data-c27-support-faq-next]');
    var pageLabel = root.querySelector('[data-c27-support-faq-page-label]');
    var currentPage = 0;
    var onPrevClick = null;
    var onNextClick = null;

    function renderPage(page) {
      currentPage = Math.max(0, Math.min(page, totalPages - 1));

      items.forEach(function (item) {
        var itemPage = parseInt(item.getAttribute('data-c27-support-faq-page') || '0', 10);
        item.hidden = itemPage !== currentPage;
      });

      if (pageLabel) {
        pageLabel.innerHTML =
          String(currentPage + 1) +
          '<span class="c27-support-popular-topics__pager-total">/' +
          totalPages +
          '</span>';
      }

      if (prevBtn) {
        prevBtn.disabled = currentPage <= 0;
        prevBtn.classList.toggle(
          'c27-support-popular-topics__pager-btn--active',
          currentPage > 0
        );
      }

      if (nextBtn) {
        nextBtn.disabled = currentPage >= totalPages - 1;
        nextBtn.classList.toggle(
          'c27-support-popular-topics__pager-btn--active',
          currentPage < totalPages - 1
        );
      }
    }

    return {
      init: function () {
        if (!items.length) return;

        renderPage(0);

        if (pager && totalPages > 1) {
          onPrevClick = function () {
            renderPage(currentPage - 1);
          };
          onNextClick = function () {
            renderPage(currentPage + 1);
          };
          if (prevBtn) prevBtn.addEventListener('click', onPrevClick);
          if (nextBtn) nextBtn.addEventListener('click', onNextClick);
        }
      },
      destroy: function () {
        if (prevBtn && onPrevClick) prevBtn.removeEventListener('click', onPrevClick);
        if (nextBtn && onNextClick) nextBtn.removeEventListener('click', onNextClick);
        onPrevClick = null;
        onNextClick = null;
      },
      getComponent: function () {
        return 'popular-topics';
      },
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.c27SupportInit === 'true') return;
    var ctrl = createController(root);
    controllerMap().set(root, ctrl);
    root.dataset.c27SupportInit = 'true';
    ctrl.init();
  }

  function destroyRoot(root) {
    if (!root) return;
    var ctrl = controllerMap().get(root);
    if (!ctrl) return;
    ctrl.destroy();
    controllerMap().delete(root);
    delete root.dataset.c27SupportInit;
  }

  function scan(container) {
    collectRoots(container).forEach(initRoot);
  }

  function destroy(container) {
    collectRoots(container).forEach(destroyRoot);
  }

  function onSectionLoad(event) {
    scan(event.target);
  }

  function onSectionUnload(event) {
    destroy(event.target);
  }

  window.__c27Support[NS] = window.__c27Support[NS] || {};
  window.__c27Support[NS].scan = scan;
  window.__c27Support[NS].destroy = destroy;
  window.__c27Support[NS].collectRoots = collectRoots;

  if (!window.__c27Support[bootKey]) {
    window.__c27Support[bootKey] = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
